import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { DataItemSublistItem } from './types'
import { Button } from '@/Atomic/Molecules/Button'
import { SublistItem, SublistItemContent } from '@/Atomic/Templates/Sublist'

interface SublistSearchResultProps {
  items: Omit<DataItemSublistItem, 'dataItem'>[]
  link: (id: string) => Promise<void>
  flashItemId?: string | null
}

export const SublistSearchResult: React.FC<SublistSearchResultProps> = ({
  items,
  link,
  flashItemId,
}) => {
  const { t } = useTranslation()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const onLinkClick = async (id: string) => {
    setIsSubmitting(true)
    await link(id).finally(() => setIsSubmitting(false))
  }

  return items.map((item) => (
    <SublistItem
      key={item.id}
      className="sublist-item-search-result"
      flash={item.id === flashItemId}
    >
      <SublistItemContent
        avatar={item.image}
        avatarIcon={item.avatarIcon}
        fallbackInitials={item.initials}
        initialsColorSeed={item.id}
        title={item.title}
        subtitle={item.subtitle}
        badgeValue={item.badgeValue}
        badgeVariant={item.badgeVariant}
        secondaryBadgeValue={item.secondaryBadgeValue}
        secondaryBadgeVariant={item.secondaryBadgeVariant}
        button={
          <Button
            icon="add"
            title={t('common.add')}
            reverse
            disabled={isSubmitting}
            buttonClassName="sublist-link-button"
            onClick={() => onLinkClick(item.id)}
          />
        }
      />
    </SublistItem>
  ))
}
